(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const forceOpen = () =>
      document
        .querySelectorAll('.accordion--always-open details:not([open])')
        .forEach((d) => (d.open = true));

    document.addEventListener(
      'toggle',
      (e) => {
        const d = e.target;
        if (d.matches?.('.accordion--always-open details') && !d.open) d.open = true;
      },
      true
    );

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forceOpen);
    else forceOpen();
    document.addEventListener('shopify:section:load', forceOpen);
  })();
  } catch(e) { console.error(e); }
})();

})();
